import { AccessibilityAuditToolNames } from '../../../shared/constants/audit-tool';
import { FeatureFlagCollection } from '../../../shared/interfaces/feature-flag.interface';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';

export function filterRulebaseIfNecessary(featureFlagService: FeatureFlagService, toolName: string): boolean {
  return (
    toolName !== AccessibilityAuditToolNames.rulebase ||
    featureFlagService.variation(FeatureFlagCollection.newAutomatedEngine, false)
  );
}
